// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import Difficulty from "./difficulty_type";


export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  username: __t.string(),
  countryCode: __t.string().name("country_code"),
  get difficulty() {
    return Difficulty;
  },
  completionTimeMs: __t.u32().name("completion_time_ms"),
  completedAt: __t.u64().name("completed_at"),
  bbbv: __t.u16(),
  bbbvPerSecond: __t.f32().name("bbbv_per_second"),
  totalLeftClicks: __t.u32().name("total_left_clicks"),
  totalRightClicks: __t.u32().name("total_right_clicks"),
  totalChords: __t.u32().name("total_chords"),
  effectiveClicks: __t.u32().name("effective_clicks"),
  ioe: __t.f32(),
  rqp: __t.f32(),
  boardWidth: __t.u8().name("board_width"),
  boardHeight: __t.u8().name("board_height"),
  minesCount: __t.u16().name("mines_count"),
  gameModeId: __t.u8().name("game_mode_id"),
  isRanked: __t.bool().name("is_ranked"),
});
